import * as React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import RadioButtons from '../RadioButtons';
import GeneratorContext from '../../GeneratorContext';

const Gender: React.FC = () => {
  const widgetGeneratorGender = useWidget(WidgetId.GeneratorGenderV3);
  const { setGenderGroup } = React.useContext(GeneratorContext);

  const [currentValue, setCurrentValue] = React.useState(
    widgetGeneratorGender.options.defaultRadioButton,
  );

  React.useEffect(() => {
    setGenderGroup(widgetGeneratorGender.options.defaultRadioButton);
  }, [setGenderGroup, widgetGeneratorGender.options.defaultRadioButton]);

  const radioValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGenderGroup(e.target.value);
    setCurrentValue(e.target.value);
  };

  return (
    <RadioButtons>
      <RadioButtons.RadioButtonGroup>
        {widgetGeneratorGender.repeaters.gender.map((item, index) => (
          <RadioButtons.RadioButton
            key={index}
            label={item.strings.title}
            id={item.options.value}
            checked={item.options.value === currentValue}
            value={item.options.value}
            onChange={radioValue}
          />
        ))}
      </RadioButtons.RadioButtonGroup>
    </RadioButtons>
  );
};

export default Gender;
